export const faDistributeVertically = {
  prefix: 'fpm',
  iconName: 'fa-distribute-vertically',
  icon: [
    24,
    24,
    [],
    'e001',
    'M3 3.5V4h18.64V3H3v.5M5.8 12v2.44h13.08V9.56H5.8V12M3 20.52V21h18.64v-.96H3v.48',
  ],
};
